import provider from "./src/store/provider"
import PageElement from './wrapPageElement'

export const wrapRootElement = provider;
export const wrapPageElement = PageElement;
